export default {
    ifYouAgreeToTheseRestrictions:
        '上記をご確認いただきご了承いただけましたら、下記のアンケートに回答のうえ、お手続きにお進みください。',
    improvements:
        '改善点などございましたら、今後の参考にさせていただきますので、ぜひお聞かせください。',
    reason: {
        option1: '使用頻度・書類の発行枚数が減った',
        option2: '他社製品・他システムへ移行した',
        option3: '機能が不十分だった',
        option4: '使い心地に満足できなかった(操作が分かりづらい等)',
        option5: '料金形態が合わなかった',
        option6: 'その他',
        selectedLabel: 'ダウングレードの理由を以下よりひとつお選びください。',
    },
    reasonDetails: '具体的にダウングレードの背景をお聞かせください。',
    title: 'プランをキャンセル - MakeLeaps',
    warning: '注意点',
    warning1:
        '無料プランは2022年1月1日施行の電子帳簿保存法改正の要件に対応していません。過去の発行書類については、ダウングレード前に「発行書類控え」ページより控えデータのダウンロードおよび保存することを推奨します。（詳細は<0>こちら</0><1></1>）',
    warning2:
        '無料プランにダウングレードされると、見積書と請求書以外、作成不可となります。その他の機能制限はこちらの<0>料金プラン</0><1></1>比較よりご確認ください。',
};
